/*
 *   File : creator.js
 *   Author : https://evoqins.com
 *   Description : Creator card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Style
import style from "../../Styles/Component/card.module.scss";

const TAGS_TO_SHOW = 3;

const CreatorCard = (props) => {
    return (
        <div className={`${style.e_creator_card_wrapper} border-radius-16 cursor-pointer h-100`}
            onClick={() => props.handleClick(props.creator.creator_id)}>
            <div className={`${style.e_creator_card} border-radius-16 p-3 h-100`}>
                <div className='d-flex gap-2 align-items-center'>
                    <div>
                        <img src={`${props.creator.creator_logourl}`}
                            draggable={false}
                            className={`${props.creator.creator_logourl !== "NULL" ? "" : "invisible"} e-border-1px-anti-flash-white border-radius-8 w-48px h48 img-fluid p-1 bg-white object-fit-contain`}
                            alt='creator' />
                    </div>
                    <div>
                        <p className='e-font-14-res mb-1 e-alt-font-lato e-text-black e-font-16 e-font-weight-600 line-height-20px'>
                            {props.creator.creator_name}
                        </p>
                        <p className='e-font-12-res mb-1 e-alt-afont-lato e-text-pixie-powder e-font-14 e-font-weight-400 line-height-20px'>
                            Baskets managed: {props.creator.basket_count_by_tenant_id}
                        </p>
                    </div>
                </div>

                <div className='pt-3 d-flex gap-2 flex-wrap align-items-center'>
                    {
                        props.creator.tag_list.slice(0, TAGS_TO_SHOW).map((tag, index) => (
                            <span key={index}
                                className='e-font-10-res e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-500 line-height-16px padding-2px-tb padding-6px-lr border-radius-4 e-bg-white e-border-0-5px-gainsboro'>
                                {tag}
                            </span>
                        ))
                    }
                    {
                        props.creator.tag_list.length > TAGS_TO_SHOW &&
                        <span className='e-font-10-res cursor-pointer e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-600 line-height-16px'>
                            +{props.creator.tag_list.length - TAGS_TO_SHOW} more
                        </span>
                    }


                </div>
            </div>

        </div>
    )
}

export default CreatorCard;

CreatorCard.defaultProps = {
    handleClick: () => { }
}